import React from 'react'
import PropTypes from 'prop-types'
import Svg from './Svg'

const ZoomIconOut = ({ className }) => (
  <Svg
    className={className}
    width="13px"
    height="11px"
  >
    <path d="M1.492 1.984a.492.492 0 1 1 0-.984.492.492 0 0 1 0 .984zM4.865 1h6.713a.492.492 0 0 1 0 .984H4.865a.492.492 0 0 1 0-.984zM1.492 5.919a.492.492 0 1 1 0-.984.492.492 0 0 1 0 .984zm3.373-.984h6.713a.492.492 0 0 1 0 .984H4.865a.492.492 0 0 1 0-.984zM1.492 9.854a.492.492 0 1 1 0-.984.492.492 0 0 1 0 .984zm3.373-.984h6.713a.492.492 0 0 1 0 .984H4.865a.492.492 0 1 1 0-.984z" fill="#4a4a4a" stroke="#4a4a4a" strokeWidth=".6" fillRule="evenodd"/>
  </Svg>
)

ZoomIconOut.propTypes = {
  className: PropTypes.string,
}

export default ZoomIconOut
